export default {
  data() {
    return {
      defaultImage: `themes/storefront/public/images/image-placeholder.png`
    }
  },
  methods: {
    handleImageError(event) {
      // Handle the image loading error by replacing the image source with the default image source
      event.target.src = this.defaultImage
    },

    baseImage(product) {
      if (this.hasBaseImage(product)) {
        return product.base_image
      }

      return `${window.Trillion.baseUrl}/themes/storefront/public/images/image-placeholder.png`
    },

    hasBaseImage(product) {
      return product.base_image !== null && product.base_image !== ""
    },

    getImage(cartItem) {
      if (cartItem.qty == 1 || !cartItem.product.qd_enabled)
        return this.baseImage(cartItem.product)
      else {
        let level = cartItem.product.quantity_discount_with_min_max.find((item) => {
          return cartItem.qty >= item.min_val && (cartItem.qty <= item.max_val || item.max_val == null)
        })
        if (level)
          if (level.media[0])
            return level.media[0].original_url
        return this.baseImage(cartItem.product)
      }
    }
  }
}
